/**
 * The use cases whose assets live in lockers/compartments — the one
 * definition of "this tenant has Fächer". Booking-list column, search hint
 * and dashboard locker filters all answer from this list; room-family use
 * cases (venue, apartment) are deliberately absent.
 */
export const LOCKER_USE_CASES = [
    'storage',
    'rental',
    'p2p',
    'parcel',
    'keys',
    'sup',
] as const;

export const hasLockerUseCase = (useCases: string[] | undefined): boolean =>
    Boolean(useCases?.some((useCase) => (LOCKER_USE_CASES as readonly string[]).includes(useCase)));
